import React, { useState } from 'react';
import { BarChart3, Package, DollarSign, Clock, TrendingUp } from 'lucide-react';
import CustomerPortalLayout from '../../components/customer-portal/CustomerPortalLayout';

const CustomerAnalytics = () => {
  const [activeTab, setActiveTab] = useState('fabric'); // fabric, payment, delivery, trends

  const tabs = [
    { id: 'fabric', label: 'Kumaş Alım Analizi', icon: Package },
    { id: 'payment', label: 'Ödeme Analizi', icon: DollarSign },
    { id: 'delivery', label: 'Teslimat Süreleri', icon: Clock },
    { id: 'trends', label: 'Trend Analizi', icon: TrendingUp },
  ];

  return (
    <CustomerPortalLayout title="Analizler" icon={BarChart3} showBackButton={true}>
      <main className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-4 sm:py-8">
        {/* Tabs */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm sm:shadow-md mb-4 sm:mb-6">
          <div className="border-b border-gray-200 dark:border-gray-700">
            <nav className="flex -mb-px overflow-x-auto">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`
                      flex items-center px-3 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm font-medium border-b-2 transition-colors whitespace-nowrap flex-shrink-0
                      ${
                        activeTab === tab.id
                          ? 'border-purple-500 text-purple-600 dark:text-purple-400'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                      }
                    `}
                  >
                    <Icon className="w-3 h-3 sm:w-4 sm:h-4 sm:mr-2" />
                    <span className="hidden sm:inline">{tab.label}</span>
                    <span className="sm:hidden">{tab.label.split(' ')[0]}</span>
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm sm:shadow-md p-4 sm:p-6">
          {activeTab === 'fabric' && (
            <div className="text-center py-12">
              <Package className="w-16 h-16 text-purple-400 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Kumaş Alım Analizi
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Belirli tarihlerde ne kadar kumaş aldığınız burada görüntülenecektir.
              </p>
            </div>
          )}

          {activeTab === 'payment' && (
            <div className="text-center py-12">
              <DollarSign className="w-16 h-16 text-green-400 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Ödeme Analizi
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Ne kadar ödeme yaptığınız ve ödeme trendleriniz burada görüntülenecektir.
              </p>
            </div>
          )}

          {activeTab === 'delivery' && (
            <div className="text-center py-12">
              <Clock className="w-16 h-16 text-blue-400 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Teslimat Süreleri
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Kumaşları kaç günde aldığınız ve teslimat süre analizleriniz burada görüntülenecektir.
              </p>
            </div>
          )}

          {activeTab === 'trends' && (
            <div className="text-center py-12">
              <TrendingUp className="w-16 h-16 text-orange-400 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Trend Analizi
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Alım ve ödeme trendleriniz burada görüntülenecektir.
              </p>
            </div>
          )}
        </div>
      </main>
    </CustomerPortalLayout>
  );
};

export default CustomerAnalytics;
